import { Building2 } from 'lucide-react'

export default function OrgMark() {
  return (
    <span
      style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        background: 'var(--accent-soft)',
        color: 'var(--accent-strong)',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Building2 size={18} />
    </span>
  )
}
